import { Calendar } from 'vanilla-calendar-pro';
import 'vanilla-calendar-pro/styles/index.css';
import axios from 'axios';


export default {
    name: 'service',
    component() {
        return {
            openPopup: false,
            step: 1,
            email: '',
            register: false,
            registerData: {
                name: '',
                first_name: '',
                email: '',
                phone_numbers: [
                    {
                        phone_number: '',
                        phone_number_id: 'mob'
                    }
                ]  
            },
            customer: null,
            bikes: [],
            repairObjectId: null,
            loadingRepairObjects: false,
            openServices: false,
            chosenService: {
                description: '',
                code: null,
                price: null,
                time_minutes: null,
                serviceOrder: null
            },
            chosenDate: null,
            contact_phone_id: null,
            newPhone: '',
            notes: null,
            repair_codes: [],
            errors: {
                login: '',
                register: '',
                bike: '',
                service: '',
                phone: '',
                workshop: '',
                calendar: '',
            },
            workshop_orders: [],
            calendar: null,

            init() {

                // this.watch('step', () => {
                //     if (this.step == null) {
                //         this.openServices = false;
                //         this.chosenService = null;
                //         this.notes = null;
                //     }
                // });

                // Check URL parameter for servicepopup
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.get('servicepopup') === 'true') {
                    this.openPopup = true;
                }

                this.getRepairCodes();
            },

            initCalendar() {
                // Only initialize once
                if (this.calendar) return;

                const options = {
                    type: 'default',
                    selectedTheme: 'light',
                    locale: 'nl',
                    disableDatesPast: true,
                    disableDates: [this.formatDateLocal(new Date())],
                    disableWeekdays: [0, 6],
                    disableToday: true,
                    selectionMonthsMode: 'only-arrows',
                    selectionYearsMode: 'only-arrows',
                    selectionDatesMode: 'single',
                    onClickDate: (self, event) => {
                        this.chosenDate = event.target.offsetParent.attributes['data-vc-date'].value;
                        this.errors.calendar = '';
                    },
                    onInit: (self) => {
                        this.checkDateAvailability(self);
                    },

                    onClickArrow: (self) => {
                        this.checkDateAvailability(self);
                    },

                    // styles: {
                    //     arrowPrev: 'fa-light fa-chevron-left',
                    //     arrowNext: 'fa-light fa-chevron-right',
                    // }
                };

                
                this.calendar = new Calendar('#calendar', options);
                this.calendar.init();
            },

            validateEmail(email) {
                return String(email)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    );
            },

            async getCustomerData() {
                if (!this.email) {
                    this.errors.login = 'Email is required';
                    return;
                }

                if(!this.validateEmail(this.email)) {
                    this.errors.login = 'Invalid email address';
                    return;
                }

                try {
                    const response = await axios.get('https://kaptein-api.option5.dev/api/customers/find', {
                        params: {
                            email: this.email
                        }
                    });
                    this.errors.login = '';
                    this.customer = response.data.data[0];
                    this.autoSelectPhoneNumber();
                    // console.log(this.customer);
                    
                    // Fetch repair objects for this customer before moving to step 2
                    await this.getRepairObjects();
                    await this.getWorkshopOrders();
                    this.step = 2;
                } catch (error) {
                    if(error.status == 404) {
                        // console.log('Customer not found');
                        this.register = true;
                    } else {
                        this.errors.login = error.response.data.message;
                        console.error('Error fetching customer data:', error);
                    }
                }
            },

            async createCustomer() {
                this.registerData.email = this.email;

                if(!this.validateEmail(this.registerData.email)) {
                    this.errors.register = 'Invalid email address';
                    return;
                }

                if(this.registerData.name == '' || this.registerData.first_name == '' || this.registerData.phone_numbers[0].phone_number == '') {
                    this.errors.register = 'All fields are required';
                    return;
                }
                
                try {
                    const response = await axios.post('https://kaptein-api.option5.dev/api/customers', this.registerData, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    this.errors.register = '';
                    this.customer = response.data.data;
                    this.autoSelectPhoneNumber();
                    // console.log(this.customer);
                    
                    // Fetch repair objects for this customer before moving to step 2
                    await this.getRepairObjects();
                    this.step = 2;
                } catch (error) {
                    console.error('Error creating customer:', error.response ? error.response.data : error.message);
                    if (error.response) {
                        this.errors.register = error.response.data?.error_message || error.response.data?.message || 'Error creating customer';
                    } else {
                        this.errors.register = 'Network error. Please try again.';
                    }
                    throw error;
                }
            },

            async addBike() {
                let bikeForm = this.$event.target.closest('[data-bikes-form]');

                let bikeBrand = bikeForm.querySelector('[data-bike-brand]').value;
                let bikeType = bikeForm.querySelector('[data-bike-type]').value;

                if(bikeBrand == '' || bikeType == '') {
                    this.errors.bike = 'Brand and type are required';
                    return;
                }

                // Check if bike already exists
                const bikeExists = this.bikes.some(
                    bike => bike.brand.toLowerCase() === bikeBrand.toLowerCase() && 
                            bike.type.toLowerCase() === bikeType.toLowerCase()
                );

                if (bikeExists) {
                    this.errors.bike = 'This bike already exists';
                    return;
                }

                this.errors.bike = '';

                // Create repair object in API
                const repairObject = await this.createRepairObject(bikeBrand, bikeType);
                
                if (repairObject) {
                    this.bikes.push({
                        repair_object_id: repairObject.object_id,
                        brand: bikeBrand,
                        type: bikeType,
                    });
                    
                    // Select the newly added bike
                    this.repairObjectId = repairObject.object_id;
                    
                    bikeForm.querySelector('[data-bike-brand]').value = '';
                    bikeForm.querySelector('[data-bike-type]').value = '';
                }
            },

            selectBike(bikeId) {
                this.repairObjectId = bikeId;
            },

            async createRepairObject(brand, model) {
                if (!this.customer || !this.customer.customer_id) {
                    this.errors.bike = 'Customer not found';
                    return null;
                }

                try {
                    const response = await axios.post(
                        `https://kaptein-api.option5.dev/api/customers/${this.customer.customer_id}/objects`,
                        {
                            customer_id: this.customer.customer_id,
                            brand: brand,
                            model: model,
                            object_barcode: "object_barcode",
                            is_active: true,
                            // object_type_name: "Unknown",
                            // category: "Unknown",
                            // model_year: "Unknown",
                            // frame_number: "Unknown",
                            // color: "Unknown"
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    // console.log('Repair object created:', response.data);
                    return response.data.data;
                } catch (error) {
                    console.error('Error creating repair object:', error.response ? error.response.data : error.message);
                    if (error.response) {
                        this.errors.bike = error.response.data?.error_message || error.response.data?.message || 'Error creating repair object';
                    } else {
                        this.errors.bike = 'Network error. Please try again.';
                    }
                    return null;
                }
            },

            async getRepairCodes() {
                try {
                    const response = await axios.get('https://kaptein-api.option5.dev/api/workshop/repair-codes');
                    this.repair_codes = response.data.data;
                    // console.log(this.repair_codes);
                } catch (error) {
                    console.error('Error fetching repair codes:', error);
                }
            },

            async getWorkshopOrders() {
                try {
                    const response = await axios.get(`https://kaptein-api.option5.dev/api/customers/${this.customer.customer_id}/service-items`);
                    this.workshop_orders = response.data.data;
                    // console.log(this.workshop_orders);
                } catch (error) {
                    console.error('Error fetching workshop orders:', error);
                }
            },

            formatDateLocal(date) {
                // Format date as YYYY-MM-DD in local timezone (avoids UTC conversion issues)
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },

            async checkDateAvailability(calendarInstance) {
                const year = calendarInstance.context.selectedYear;
                const month = calendarInstance.context.selectedMonth;
                const requiredMinutes = this.chosenService.time_minutes || 180;
                
                const firstDay = new Date(year, month, 1);
                const lastDay = new Date(year, month + 2, 0);
                const firstDayStr = this.formatDateLocal(firstDay);
                
                try {
                    const response = await axios.get('https://kaptein-api.option5.dev/api/workshop/trading-hours', {
                        params: {
                            store_id: null,
                            start_date: firstDayStr,
                            // day_count: 31,
                            day_count: 62,
                        }
                    });
                    
                    const tradingHoursData = response.data?.data || [];
                    const availabilityMap = {};
                    
                    if (Array.isArray(tradingHoursData)) {
                        tradingHoursData.forEach(day => {
                            if (day.date) {
                                availabilityMap[day.date] = day.available_minutes || 0;
                            }
                        });
                    }
                    
                    const unavailableDates = [];
                    
                    const currentDate = new Date(firstDay);
                    while (currentDate <= lastDay) {
                        const dateStr = this.formatDateLocal(currentDate);
                        
                        if (!(dateStr in availabilityMap)) {
                            unavailableDates.push(dateStr);
                        } else {
                            const availableMinutes = availabilityMap[dateStr];
                            
                            if (availableMinutes < requiredMinutes) {
                                unavailableDates.push(dateStr);
                            }
                        }
                        
                        currentDate.setDate(currentDate.getDate() + 1);
                    }
                    
                    if (unavailableDates.length > 0) {                        
                        const existingDisabled = this.calendar.disableDates || [];
                        this.calendar.disableDates = [
                            ...existingDisabled,
                            ...unavailableDates
                        ];
                        
                        this.calendar.update({ 
                            dates: true,
                            month: false,
                            year: false 
                        });
                    }                    
                    // console.log('Date availability checked:', { month: month + 1, year, requiredMinutes, unavailableDates });
                } catch (error) {
                    console.error('Error checking date availability:', error);
                }
            },

            async getRepairObjects() {
                if (!this.customer || !this.customer.customer_id) {
                    console.error('Customer ID is required to fetch repair objects');
                    return;
                }

                this.loadingRepairObjects = true;

                try {
                    const response = await axios.get(`https://kaptein-api.option5.dev/api/customers/${this.customer.customer_id}/objects`);
                    
                    this.repairObjects = response.data.data || [];
                    
                    this.bikes = this.repairObjects.map(obj => ({
                        repair_object_id: obj.object_id,
                        brand: obj.brand || '',
                        type: obj.model || '',
                        frame_number: obj.frame_id || '',
                    }));
                    
                    if (this.bikes.length > 0) {
                        this.repairObjectId = this.bikes[0].repair_object_id;
                    }
                    
                    
                    console.log('Repair objects found:', this.repairObjects);
                } catch (error) {
                    console.error('Error fetching repair objects:', error);
                    // On any error, continue with empty array so user can still add bikes manually
                    this.repairObjects = [];
                    this.bikes = [];
                } finally {
                    this.loadingRepairObjects = false;
                }
            },

            selectPhoneNumber(phoneNumberId) {
                this.contact_phone_id = phoneNumberId;
            },

            autoSelectPhoneNumber() {
                if (!this.customer || !this.customer.phone_numbers) {
                    return;
                }

                // Filter to only phone numbers that have a value
                const validPhones = this.customer.phone_numbers.filter(
                    phone => phone.phone_number != null && phone.phone_number !== ''
                );

                if (validPhones.length === 0) {
                    return;
                }

                // First, try to find a phone with ID 'mob'
                const mobPhone = validPhones.find(phone => phone.phone_number_id === 'mob');
                
                if (mobPhone) {
                    this.contact_phone_id = mobPhone.phone_number_id;
                } else {
                    // Otherwise, select the first valid phone number
                    this.contact_phone_id = validPhones[0].phone_number_id;
                }
            },

            async addPhoneNumber(number) {
                if(number == '' || number == null) {
                    this.errors.phone = 'Phone number is required';
                    return;
                }

                if (!this.customer || !this.customer.customer_id) {
                    this.errors.phone = 'Customer not found';
                    return;
                }

                const mobPhoneIndex = this.customer.phone_numbers.findIndex(
                    phone => phone.phone_number_id === 'mob'
                );

                let newPhoneNumberId = 'mob';
                
                if (mobPhoneIndex !== -1) {
                    this.customer.phone_numbers[mobPhoneIndex].phone_number = number;
                    newPhoneNumberId = this.customer.phone_numbers[mobPhoneIndex].phone_number_id;
                } else {
                    this.customer.phone_numbers.push({
                        phone_number: number,
                        phone_number_id: 'mob'
                    });
                }

                // console.log(this.customer);

                this.contact_phone_id = newPhoneNumberId;
                this.newPhone = '';

                this.updateCustomer();
            },

            async updateCustomer() {
                try {
                    // Remove datetime_created from params
                    const { datetime_created, ...customerData } = this.customer;
                    // console.log(this.customer);
                    
                    const response = await axios.put(
                        `https://kaptein-api.option5.dev/api/customers/${this.customer.customer_id}`,
                        customerData,
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    this.errors.phone = '';
                    this.customer = response.data.data;
                    // console.log('Customer updated:', this.customer);
                } catch (error) {
                    console.error('Error updating customer:', error.response ? error.response.data : error.message);
                    if (error.response) {
                        this.errors.phone = error.response.data?.error_message || error.response.data?.message || 'Error updating customer';
                    } else {
                        this.errors.phone = 'Network error. Please try again.';
                    }
                    throw error;
                }
            },

            async createWorkshopOrder() {
                if(!this.chosenDate) {
                    this.errors.calendar = 'Date is required';
                    return;
                }

                // Format the date to YYYY-MM-DD HH:MM:SS format
                let formattedDate = this.chosenDate;
                // If chosenDate is just a date (YYYY-MM-DD), add a default time
                if (formattedDate && formattedDate.length === 10) {
                    formattedDate = `${formattedDate}T09:00:00+01:00`;
                }
                
                // if (this.notes && this.notes.trim()) {
                //     repairDescription = `${this.notes}`;
                // }

                // console.log(this.chosenService.serviceOrder);
                // console.log(typeof this.chosenService.serviceOrder);

                const workshopOrderData = {
                    customer_id: this.customer.customer_id,
                    datetime_scheduled_start: formattedDate,
                    phone_number_id: this.contact_phone_id,
                    repair_codes: this.chosenService.code != null ? [this.chosenService.code.toString()] : [],
                    service_card_codes: this.chosenService.serviceOrder != null ? [this.chosenService.serviceOrder.toString()] : [],
                    repair_description: this.notes ? this.notes : "",
                    store_id: null, // or get from customer/store config
                    repair_object_id: this.repairObjectId // or create repair object first
                };

                try {
                    const response = await axios.post(
                        `https://kaptein-api.option5.dev/api/customers/${this.customer.customer_id}/workshop-order`,
                        workshopOrderData,
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    this.errors.workshop = '';
                    console.log('Workshop order created:', response.data);
                } catch (error) {
                    console.error('Error creating workshop order:', error);
                    
                    if (error.response) {
                        const errorData = error.response.data;
                        console.error('Full error details:', {
                            status: error.response.status,
                            statusText: error.response.statusText,
                            data: errorData
                        });
                    } else {
                        this.errors.workshop = 'Network error. Please try again.';
                    }
                    throw error;
                }
                this.step = 5;
            }
        }
    }
}